import React, { useEffect, useState } from "react";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import countryToCurrency from "country-to-currency";
import { arrayMoveImmutable } from "array-move";
import { customSelectStyles } from "./sharedUtils";
import Select from "react-select";

const currencyOptions = Object.keys(countryToCurrency).map((key) => ({
  label: countryToCurrency[key],
  value: countryToCurrency[key],
  country: key,
}));

const parseMoney = (currencyString, defaultCurrency = 'THB') => {
  if (!currencyString) return { value: "", currency: defaultCurrency };
  const valueMatch = String(currencyString).match(/\d[\d,]*(?:\.\d+)?/);
  if (!valueMatch) return { value: "", currency: defaultCurrency };

  const currencyMatch = String(currencyString).match(/THB|USD|EUR|VND|[฿$€₫]/i);
  const currencyAliases = { '฿': 'THB', '$': 'USD', '€': 'EUR', '₫': 'VND' };
  const token = currencyMatch ? currencyMatch[0] : defaultCurrency;
  const currency = currencyAliases[token] || token.toUpperCase();
  const value = Number(valueMatch[0].replace(/,/g, ''));

  if (currencyOptions.some((option) => option.value.toUpperCase() === currency)) {
    return { value, currency };
  }
  return { value: "", currency: defaultCurrency };
};

const CurrencyInput = (props) => {
  const { onChange, defaultCurrency } = props;
  const parsedMoney = parseMoney(props.value, defaultCurrency);
  const [value, setValue] = useState(parsedMoney.value);
  const [currency, setCurrency] = useState(parsedMoney.currency);
  const handleChangeValue = (e) => {
    setValue(e.target.value);
    onChange(`${e.target.value || ""}${currency}`);
  };
  const handleChangeCurrency = (e) => {
    setCurrency(e ? e : "");
    console.log('handleChangeCurrency', e);
    onChange(`${value}${e ? e.value : ""}`);
  };
  useEffect(() => {
    const money = parseMoney(props.value, defaultCurrency);
    setValue(money.value);
    setCurrency(money.currency);
  }, [props.value]);
  console.log('props.value', props.value, value, currency)
  return (
    <div className="price-selector" style={{ display: "flex" }}>
      <input
        type="number"
        className="form-input"
        aria-label="price"
        value={`${value || ""}`}
        onChange={handleChangeValue}
      />
      <Select
        styles={customSelectStyles}
        className="react-select-wrapper react-select-currency"
        classNamePrefix="react-select"
        options={currencyOptions}
        isMulti={false}
        name="currency"
        placeholder="currency"
        required={true}
        value={currencyOptions.find((item) => item.value === currency)}
        onChange={handleChangeCurrency}
      />
    </div>
  );
};

const DragHandle = sortableHandle(() => (
  <div className="fm-move">
    <i className="sl sl-icon-cursor-move"></i>
  </div>
));

const SortableItem = SortableElement(({ menu, onChange, onDelete }) => {
  window.countryToCurrency = countryToCurrency;
  return (
    <tr
      key={`${menu.id}`}
      className="pricing-list-item pattern ui-sortable-handle"
    >
      <td>
        <DragHandle />
      </td>
      <td>
        <div className="fm-input pricing-name">
          <input
            className="form-input"
            type="text"
            placeholder="Title"
            value={`${menu.title || ""}`}
            onChange={(e) => onChange({ ...menu, title: e.target.value })}
          />
        </div>
      </td>
      <td>
        <div className="fm-input pricing-ingredients">
          <input
            className="form-input"
            type="text"
            placeholder="Description"
            value={`${menu.desc || ""}`}
            onChange={(e) => onChange({ ...menu, desc: e.target.value })}
          />
        </div>
      </td>
      <td style={{ maxWidth: '150px' }}>
        <div className="fm-input">
          <CurrencyInput
            value={`${menu.price || ""}`}
            onChange={(val) => onChange({ ...menu, price: val })}
          />
        </div>
      </td>
      <td>
        <div className="fm-close">
          <a
            className="delete btn btn-red"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              return onDelete(menu);
            }}
          >
            <i className="fa fa-remove"></i>
          </a>
        </div>
      </td>
    </tr>
  );
});

const SortableList = SortableContainer(
  ({ items, onChangeItem, onDeleteItem }) => {
    return (
      <tbody className="ui-sortable">
        {items.map((item, index) => (
          <SortableItem
            key={`item-${item.id}-${index}`}
            index={index}
            menu={item}
            onChange={(menu) => onChangeItem(index, menu)}
            onDelete={(menu) => onDeleteItem(index, menu)}
          />
        ))}
      </tbody>
    );
  }
);

const FormMenus = (props) => {
  const { setFieldValue } = props;
  const [menus, setMenus] = useState(props.values.menus || [{}]);
  const handleAddOne = (e) => {
    e.preventDefault();
    setMenus([...menus, {}]);
  };
  const handleOnSort = ({ oldIndex, newIndex }) => {
    const newMenus = arrayMoveImmutable(menus, oldIndex, newIndex);
    setMenus(newMenus);
    setFieldValue("menus", newMenus);
  };

  const handleChangeItem = (idx, menu) => {
    console.log(idx, menu);
    const newMenus = [...menus];
    newMenus[idx] = { ...menu };
    setMenus([...newMenus]);
    setFieldValue("menus", newMenus);
  };
  const handleDeleteItem = (idx, menu) => {
    const newMenus = [...menus];
    newMenus.splice(idx, 1);
    setMenus([...newMenus]);
    setFieldValue("menus", newMenus);
  };
  useEffect(() => {
    if (props.values && props.values.menus != menus) {
      setMenus(props.values.menus || []);
    }
  }, [props.values, props.values.menus]);
  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-tag"></i> Menu
          </h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <table id="utf_pricing_list_section">
              <SortableList
                useDragHandle
                items={menus}
                onSortEnd={handleOnSort}
                onChangeItem={handleChangeItem}
                onDeleteItem={handleDeleteItem}
              />
            </table>
            <a
              href="#"
              onClick={handleAddOne}
              className="button btn btn-secondary add-pricing-list-item"
            >
              Add Item
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormMenus;
